// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"ad3f740a","553":"b1283fc2","977":"87491ccc"}[chunkId] + ".chunk.js";
};